import { render, staticRenderFns } from "./goal-status-report.vue?vue&type=template&id=d4c9ea80"
import script from "./goal-status-report.vue?vue&type=script&lang=ts"
export * from "./goal-status-report.vue?vue&type=script&lang=ts"
import style0 from "./goal-status-report.vue?vue&type=style&index=0&id=d4c9ea80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports